module.exports = __webpack_public_path__ + "static/media/step_complete_check_icn.2cf9f547.svg";